<template>
  <transition name="transition-slide-right">
    <TradeView v-if="hasTradeRequest" />
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import TradeView from './TradeView'

export default {
  name: 'SideStockTrade',
  components: { TradeView },
  computed: {
    ...mapGetters(['hasTradeRequest'])
  }
}
</script>
